<template>
  <div :class="isWidget ? 'tool-widget' : 'tool-page'">
    <div class="tool-content">
      <div v-if="!isWidget" class="tool-heading">
        <div><h2>视频混剪</h2><p>组合多个视频素材，通过模式和附加选项生成新视频</p></div>
        <app-icon  class="app-icon" name="movie_edit"></app-icon>
      </div>
      <div class="tool-card">
        <section class="section-block">
          <div class="section-header upload-header">
            <div class="section-title">上传视频</div>
            <el-button v-if="!isWidget" type="text" size="small" class="record-button" @click="$router.push('/user2/record')">
              <i class="el-icon-time"></i> 制作记录
            </el-button>
          </div>
          <qhyuploadv2 ref="qhyupload"></qhyuploadv2>
        </section>
        <template v-if="modesLoading">
          <section class="section-block">
            <div class="section-title">混剪模式</div>
            <div class="chip-row skeleton-row">
              <span v-for="n in 6" :key="'m' + n" class="skeleton-chip"></span>
            </div>
          </section>
          <section class="section-block">
            <div class="section-title">附加选项</div>
            <div class="chip-row skeleton-row">
              <span v-for="n in 8" :key="'o' + n" class="skeleton-chip"></span>
            </div>
          </section>
        </template>
        <section v-if="!modesLoading" class="section-block">
          <div class="section-title">混剪模式</div>
          <div class="chip-row">
            <button v-for="(item, index) in ms_data.ms_list" :key="index" type="button" class="chip"
              :class="{ active: ms_xz.name === item.name }" @click="ms_xz = item">{{ item.name }}</button>
          </div>
          <p class="mode-tip">功能介绍：{{ ms_xz.title }}</p>
        </section>
        <section v-if="!modesLoading" class="section-block">
          <div class="section-title">附加选项 <small>建议最多选择 5 个</small></div>
          <div class="chip-row">
            <button v-for="(item, index) in ms_data.other" :key="index" type="button" class="chip"
              :class="{ active: item.zt }" @click="item.zt = !item.zt">{{ item.name }}</button>
          </div>
        </section>
        <section class="section-block">
          <div class="section-title">更多设置</div>
          <div class="setting-row"><span>固定音乐</span><div>为第 <el-input-number v-model="hj_data.music" :min="0" size="mini"></el-input-number> 个视频</div></div>
          <div class="setting-row"><span>固定开头</span><div>为第 <el-input-number v-model="hj_data.kt" :min="0" size="mini"></el-input-number> 个视频</div></div>
          <div class="setting-row"><span>生成视频数量</span><el-input-number v-model="hj_data.num" :min="1" :max="10" size="mini"></el-input-number></div>
        </section>
        <el-button class="submit-btn" type="primary" @click="ks">立即制作</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import LegacyHj from '../User/Hj.vue'
import qhyuploadv2 from '@/components/common/qhyuploadv2.vue'

export default {
  name: 'User2Hj',
  extends: LegacyHj,
  components: { qhyuploadv2 },
  props: { limit: { type: Number, default: 0 } },
  data() {
    return { modesLoading: true }
  },
  computed: {
    isWidget() { return this.limit > 0 }
  },
  methods: {
    get_ms() {
      this.modesLoading = true
      this.$ajax.post('/qhy/user/ms_hj', {}, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
        if (res.data && res.data.status === 200) {
          this.ms_data = res.data.data
          this.ms_xz = this.ms_data.ms_list[0]
          for (let index = 0; index < this.ms_data.other.length; index++) {
            const element = this.ms_data.other[index]
            this.hj_data[element.value] = 0
          }
        }
      }).catch(() => {
        this.$msg.error('模式加载失败')
      }).finally(() => {
        this.modesLoading = false
      })
    }
  }
}
</script>

<style scoped>
.tool-page { min-height: 100%; padding: 24px 24px 48px; background: #f5f7fa; box-sizing: border-box; }
.tool-widget { box-sizing: border-box; }
.tool-widget .tool-card { padding: 0 0 24px; border: 0; box-shadow: none; }
.tool-widget .section-block:first-child .section-title { display: none; }
.tool-content { max-width: 1080px; margin: 0 auto; }
.tool-page .tool-content { padding-bottom: 48px; }
.tool-heading { display: flex; align-items: center; justify-content: space-between; margin-bottom: 18px; }
.tool-heading h2 { margin: 0 0 6px; color: #1e293b; font-size: 22px; }
.tool-heading p, .mode-tip { margin: 0; color: #94a3b8; font-size: 13px; }
.tool-heading > span { padding: 11px; border-radius: 12px; background: #e8f1fe; color: #1a73e8; font-size: 28px; }
.tool-card { padding: 24px 24px 48px; border: 1px solid #e2e8f0; border-radius: 12px; background: #fff; box-shadow: 0 4px 16px rgba(15, 23, 42, .04); }
.section-block + .section-block { margin-top: 26px; }
.section-title { margin-bottom: 12px; color: #1e293b; font-size: 14px; font-weight: 600; }
.section-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; }
.section-header.upload-header { margin-bottom: 15px; }
.section-header .section-title { margin-bottom: 0; }
.record-button { padding: 0; }
.section-title small { margin-left: 6px; color: #94a3b8; font-weight: 400; }
.chip-row { display: flex; flex-wrap: wrap; gap: 8px; }
.chip { min-width: 76px; padding: 8px 15px; border: 1px solid #e2e8f0; border-radius: 8px; background: #f8fafc; color: #64748b; cursor: pointer; transition: .2s; }
.chip:hover { border-color: #93c5fd; color: #1a73e8; }
.chip.active { border-color: #1a73e8; background: #1a73e8; color: #fff; }
.mode-tip { margin-top: 10px; }
.setting-row { display: flex; align-items: center; justify-content: space-between; min-height: 44px; border-bottom: 1px solid #f1f5f9; color: #475569; font-size: 13px; }
.setting-row > div { color: #94a3b8; }
.setting-row /deep/ .el-input-number { width: 105px; margin: 0 5px; }
.submit-btn { width: 100%; margin-top: 30px; border-color: #1a73e8; background: #1a73e8; }
/* 模式加载骨架 */
.skeleton-row { display: flex; flex-wrap: wrap; gap: 8px; }
.skeleton-chip {
  width: 76px;
  height: 34px;
  border-radius: 8px;
  background: linear-gradient(90deg, #eef1f5 25%, #f8fafc 50%, #eef1f5 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.4s infinite;
}
@keyframes skeleton-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
@media (max-width: 768px) { .tool-page { padding: 14px 14px 32px; } .tool-card { padding: 16px 16px 32px; } .tool-page .tool-content { padding-bottom: 32px; } }
</style>



// WEBPACK FOOTER //
// src/components/User2/Hj.vue